import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pegawaiService from "../../services/pegawaiService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pegawai: false,
    data_pegawai: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPegawai = createAsyncThunk('pegawai/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getPegawaiPengawas = createAsyncThunk('pegawai/per_pengawas',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.pegawai_per_pengawas(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {}
})

export const getPegawaiProyek = createAsyncThunk('pegawai/per_proyek',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.pegawai_per_proyek(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {}
})

export const getPegawaiTanggalBayar = createAsyncThunk('pegawai/per_tanggal_bayar',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.pegawai_per_tanggal_bayar(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {}
})

export const getaDataImport = createAsyncThunk('pegawai/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('pegawai/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('pegawai/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const initImport = createAsyncThunk('pegawai/init_import',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.init_import(localStorage.getItem(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response.data)
    }
})

export const getImportProgress = createAsyncThunk('pegawai/get_import_progress',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.get_import_progress(localStorage.getItem(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response.data)
    }
})

export const saveImportBatch = createAsyncThunk('pegawai/save_import_batch',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiService.save_import_batch(localStorage.getItem(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response.data)
    }
})

export const pegawaiSlice = createSlice({
    name: 'pegawai',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pegawai = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPegawai.fulfilled, (state, action) => {
                state.loading_pegawai = false
                state.data_pegawai = action.payload??[]
            })
            .addCase(getDataPegawai.pending, (state) => {
                state.loading_pegawai = true
            })
            .addCase(getDataPegawai.rejected, (state, action) => {
                state.loading_pegawai = false
                state.data_pegawai = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_pegawai = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_pegawai = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_pegawai = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = pegawaiSlice.actions

export default pegawaiSlice.reducer
